import React from 'react';
import { Card } from '../../styled/components';
import { ToolsRecoveryProgressAggregate } from '../tools/ToolsRecoveryProgressAggregate';

export const RecoveryProgress: React.FC = () => {
  return (
    <Card sx={{ pt: 2 }}>
      <ToolsRecoveryProgressAggregate dense withExport />
    </Card>
  );
};
